import { t } from 'c-3po';
import React from 'react';
import css from './recommendation.sss';

export const ClientRecommendationMsg = ({ safetyRecommendationUrl }) => {
    return (
        <div className={css.recommendation}>
            <div className={css.header}>
                {t`Рекомендации по безопасности:`}
            </div>
            <ul className={css.list}>
                <li className={css.item}>{t`- Не соглашайтесь на предоплату;`}</li>
                <li className={css.item}>{t`- Используйте доставку наложенным платежом;`}</li>
                <li className={css.item}>{t`- Проверяйте товар при получении;`}</li>
                <li className={css.item}>{t`- Cохраняйте чеки, почтовые накладные и т.д;`}</li>
                <li className={css.item}>{t`- Выбирайте для встречи людные места.`}</li>
            </ul>
            <a href={safetyRecommendationUrl}>{t`Посмотреть все рекомендации`}</a>
        </div>
    )
};
